// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".el-table td.paid-cargo-volume,\n.el-table th.paid-cargo-volume {\n  width: 10em;\n}\n.el-table td.paid-cargo-volume {\n  text-align: right;\n}", ""]);
// Exports
module.exports = exports;
